class EmblaSlider extends HTMLElement {
  constructor() {
    super();

    this.viewport = this.querySelector(".embla__viewport");
    this.nav = this.viewport.querySelector(".js-nav");
    const prevBtnNode = this.viewport.querySelector(".js-embla-prev");
    const nextBtnNode = this.viewport.querySelector(".js-embla-next");
    const options = {
      loop: this.dataset.loop === "true",
      slidesToScroll: this.dataset.slidesToScroll || 1,
    };
    if (this.dataset.align) {
      options.align = this.dataset.align;
    }
    if (options.align === "center") {
      options.containScroll = true;
    }
    
    this.handleDrag = this.handleDrag.bind(this);
    this.slider = EmblaCarousel(this.viewport, {
      ...options,
      watchDrag: this.handleDrag,
    });

    if (prevBtnNode && nextBtnNode) {
      const removePrevNextBtnsClickHandlers = this.addPrevNextBtnsClickHandlers(
        this.slider,
        prevBtnNode,
        nextBtnNode
      );
      this.slider.on("destroy", removePrevNextBtnsClickHandlers);
    }
    this.slider.on("resize", this.handleDrag);
    this.handleDrag(this.slider);
  }

  handleDrag(emblaApi) {
    const canDrag = emblaApi.scrollSnapList().length > 1;
    if (canDrag !== this.canDrag) {
      this.toggleDragChange(canDrag);
    }
    return canDrag;
  }

  toggleDragChange(canDrag) {
    this.canDrag = canDrag;
    if (this.nav) {
      if (canDrag) {
        this.nav.style.display = "";
      } else {
        this.nav.style.display = "none";
      }
    }
  }

  addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute("disabled");
      else prevBtn.setAttribute("disabled", "disabled");

      if (emblaApi.canScrollNext()) nextBtn.removeAttribute("disabled");
      else nextBtn.setAttribute("disabled", "disabled");
    };

    emblaApi
      .on("select", togglePrevNextBtnsState)
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState);

    return () => {
      prevBtn.removeAttribute("disabled");
      nextBtn.removeAttribute("disabled");
    };
  }
  addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => {
      emblaApi.scrollPrev();
    };
    const scrollNext = () => {
      emblaApi.scrollNext();
    };
    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn
    );

    return () => {
      removeTogglePrevNextBtnsActive();
      prevBtn.removeEventListener("click", scrollPrev, false);
      nextBtn.removeEventListener("click", scrollNext, false);
    };
  }
}

customElements.define("embla-slider", EmblaSlider);
